import React from 'react';
import PropTypes from 'prop-types';
import StreamSelectMenu from './stream_menu';
import YoutubeEmbed from './embeds/youtube';
import TwitchEmbed from "./embeds/twitch";

class Stream extends React.Component {
    static get DEFAULT_STREAM() {
        return 'lv';
    }

    static get LAST_STREAM_STORAGE_KEY() {
        return 'last_stream';
    }

    static get propTypes() {
        return {
            streams: PropTypes.object,
            preferredStream: PropTypes.string,
            availableStreams: PropTypes.array,
        };
    }

    constructor(props) {
        super(props);

        this.handleStreamSelectChange = this.handleStreamSelectChange.bind(this);

        this.state = {
            lastSelectedStream: this.getLastSelectedStream(),
            selectedStream: this.autoSelectStream(),
        };
    }

    getLastSelectedStream() {
        return localStorage.getItem(Stream.LAST_STREAM_STORAGE_KEY);
    }

    autoSelectStream() {
        let availableStreams = Object.keys(this.props.streams);
        let lastSelectedStream = this.getLastSelectedStream();

        if (lastSelectedStream !== null && availableStreams.indexOf(lastSelectedStream) !== -1) {
            return lastSelectedStream;
        } else if (availableStreams.indexOf(this.props.preferredStream) !== -1) {
            return this.props.preferredStream;
        } else if (availableStreams.indexOf(Stream.DEFAULT_STREAM) !== -1) {
            return Stream.DEFAULT_STREAM;
        } else {
            return availableStreams[0];
        }
    }

    handleStreamSelectChange(stream) {
        localStorage.setItem(Stream.LAST_STREAM_STORAGE_KEY, stream);

        this.setState({
            selectedStream: stream,
        });
    }

    render() {
        return (
            <div>
                <div className="stream-top">
                    <div className="main-title">{this.props.streams[this.state.selectedStream].streamTitle}</div>
                    <StreamSelectMenu
                        streams={this.props.streams}
                        currentStream={this.state.selectedStream}
                        onStreamChange={this.handleStreamSelectChange}
                    />
                </div>
                <div className="stream">
                    { this.props.streams[this.state.selectedStream]['platform'] === 'youtube' &&
                        <YoutubeEmbed
                            watchId={this.props.streams[this.state.selectedStream]['watchId']}
                            channelId={this.props.streams[this.state.selectedStream]['channelId']}
                        />
                    }

                    { this.props.streams[this.state.selectedStream]['platform'] === 'twitch' &&
                        <TwitchEmbed userName={this.props.streams[this.state.selectedStream]['channelId']}/>
                    }
                </div>
            </div>
        );
    }
}

export default Stream;